import { IconFn, IconSvg } from "../createIcon";

export const ArrowUpIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }} {...props}>
    <g clipPath="url(#clip0_1676_16539)">
      <path
        d="M41.1429 37.4277L24 20.2849L6.85714 37.4277L-1.01157e-06 33.9992L24 9.99916L48 33.9992L41.1429 37.4277Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1676_16539">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
